
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      category: 'Yangın Tüpü Dolumu',
      questions: [
        {
          question: 'Yangın tüpü dolumu ne zaman yapılmalıdır?',
          answer: 'Yangın tüpü dolumu, tüp kullanıldıktan sonra veya periyodik kontrollerde basınç kaybı tespit edildiğinde yapılmalıdır. Ayrıca, tüpün üzerindeki etiket tarihine göre düzenli dolum periyotları vardır. Genellikle kuru kimyevi tozlu tüpler 2 yılda bir, köpüklü tüpler yılda bir kez dolum gerektirir.',
        },
        {
          question: 'Yangın tüpü dolum fiyatları nedir?',
          answer: 'Yangın tüpü dolum fiyatları, tüpün tipi (tozlu, köpüklü, CO₂), boyutu ve dolum malzemesine göre değişiklik gösterir. Detaylı fiyat teklifi için bizimle iletişime geçebilirsiniz. Toplu dolum işlemlerinde özel indirimler sunuyoruz.',
        },
        {
          question: 'Yangın tüpü dolumu ne kadar sürer?',
          answer: 'Yangın tüpü dolum işlemi genellikle 1-2 saat içinde tamamlanır. Toplu dolum işlemlerinde süre değişebilir. Hızlı servis seçeneğimizle aynı gün teslimat yapıyoruz.',
        },
      ],
    },
    {
      category: 'Yangın Tüpü Bakımı',
      questions: [
        {
          question: 'Yangın tüpü bakım periyodu ne kadardır?',
          answer: 'Yangın tüpü bakım ve periyodik kontrol işlemleri yılda en az bir kez yapılmalıdır. Bazı tüp tipleri ve kullanım alanlarına göre bu süre 6 aya kadar düşebilir. Düzenli bakım, yangın anında tüpün çalışmasını garanti eder.',
        },
        {
          question: 'Yangın tüpü bakımında neler yapılır?',
          answer: 'Bakım işleminde tüpün gövde kontrolü, basınç kontrolü, hortum ve valf kontrolü, güvenlik pimi kontrolü yapılır. Gerekli durumlarda parça değişimi ve dolum işlemi gerçekleştirilir. Her bakım sonrası detaylı rapor ve etiketleme yapılır.',
        },
        {
          question: 'Bakım sonrası belge veriliyor mu?',
          answer: 'Evet, her bakım işlemi sonrasında detaylı bakım raporu ve etiketleme yapılır. Bu belgeler yasal zorunluluklar ve sigorta için gereklidir. Bir sonraki bakım tarihi de etiket üzerinde belirtilir.',
        },
      ],
    },
    {
      category: 'Baca Temizliği',
      questions: [
        {
          question: 'Baca temizliği ne zaman yapılmalıdır?',
          answer: 'Baca temizliği yılda en az bir kez, tercihen ısınma sezonundan önce yapılmalıdır. Yoğun kullanılan bacalarda yılda iki kez temizlik önerilir. Düzenli temizlik yangın riskini önemli ölçüde azaltır.',
        },
        {
          question: 'Baca temizliği fiyatları nedir?',
          answer: 'Baca temizliği fiyatları, bacanın tipi, yüksekliği, kirliliği ve erişim zorluğuna göre değişiklik gösterir. Ücretsiz keşif sonrası net fiyat teklifi sunuyoruz.',
        },
        {
          question: 'Baca temizliği neden önemlidir?',
          answer: 'Kirli bacalar yangın riskini artırır, zehirli gaz birikimine neden olur ve ısınma verimliliğini düşürür. Düzenli temizlik hem güvenlik hem de tasarruf sağlar. Ayrıca bazı bölgelerde yasal zorunluluktur.',
        },
      ],
    },
    {
      category: 'Davlumbaz Temizliği',
      questions: [
        {
          question: 'Davlumbaz temizliği ne sıklıkla yapılmalıdır?',
          answer: 'Restoran ve endüstriyel mutfaklarda davlumbaz temizliği 3-6 ayda bir yapılmalıdır. Yoğun kullanılan mutfaklarda bu süre daha kısa olabilir. Düzenli temizlik yangın riskini önemli ölçüde azaltır.',
        },
        {
          question: 'Davlumbaz kanal temizliği neden önemlidir?',
          answer: 'Davlumbaz kanallarında biriken yağ ve gres yangın için en büyük risk faktörüdür. Düzenli temizlik yangın riskini azaltır, havalandırma verimliliğini artırır ve hijyen standartlarını sağlar.',
        },
        {
          question: 'Temizlik sırasında mutfak kapalı mı kalır?',
          answer: 'Temizlik işlemi genellikle mutfağın kapalı olduğu saatlerde yapılır. Acil durumlar için hızlı temizlik seçeneğimiz mevcuttur. İşletmenizin çalışma saatlerini aksatmamaya özen gösteriyoruz.',
        },
      ],
    },
    {
      category: 'Otomatik Davlumbaz Söndürme Sistemi',
      questions: [
        {
          question: 'Otomatik davlumbaz söndürme sistemi nedir?',
          answer: 'Otomatik davlumbaz söndürme sistemi, mutfak yangınlarını otomatik olarak algılayıp söndüren akıllı bir güvenlik sistemidir. Yüksek sıcaklık tespit edildiğinde sistem devreye girer ve yangını anında söndürür.',
        },
        {
          question: 'Hangi mutfaklar için zorunludur?',
          answer: 'Restoran, otel, hastane, okul yemekhanesi gibi ticari mutfaklarda otomatik yangın söndürme sistemi yasal zorunluluktur. Özellikle yüksek kapasiteli pişirme ekipmanı kullanan işletmeler için şarttır.',
        },
        {
          question: 'Davlumbaz söndürme sistemi bakımı ne sıklıkla yapılmalıdır?',
          answer: 'Otomatik davlumbaz söndürme sistemi bakımı yılda en az iki kez yapılmalıdır. Yoğun kullanılan mutfaklarda 6 ayda bir bakım önerilir. Bakım sırasında tüm bileşenler kontrol edilir ve test edilir.',
        },
      ],
    },
    {
      category: 'Genel Sorular',
      questions: [
        {
          question: 'Hangi bölgelerde hizmet veriyorsunuz?',
          answer: '[Şehir] ve tüm ilçelerinde hizmet vermekteyiz. Acil durumlar için hızlı müdahale ekibimiz mevcuttur. Detaylı bilgi için bizimle iletişime geçebilirsiniz.',
        },
        {
          question: 'Ödeme seçenekleri nelerdir?',
          answer: 'Nakit, kredi kartı ve havale/EFT ile ödeme kabul ediyoruz. Kurumsal müşterilerimiz için fatura ve çek ödeme seçenekleri de mevcuttur.',
        },
        {
          question: 'Acil durumlarda hizmet veriyor musunuz?',
          answer: 'Evet, acil durumlar için 7/24 hizmet vermekteyiz. Acil yangın tüpü dolumu, bakım veya ekipman ihtiyaçlarınız için bizi arayabilirsiniz.',
        },
        {
          question: 'Toplu alımlarda indirim var mı?',
          answer: 'Evet, toplu yangın tüpü alımları, toplu bakım işlemleri ve kurumsal anlaşmalarda özel indirimler sunuyoruz. Detaylı bilgi için teklif talebinde bulunabilirsiniz.',
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Sık Sorulan Sorular
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Yangın güvenliği hizmetlerimiz hakkında merak ettikleriniz
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {faqs.map((category, categoryIndex) => (
            <div key={categoryIndex} className="mb-12">
              <h2 className="font-display font-bold text-3xl text-dark-900 mb-8">
                {category.category}
              </h2>
              <div className="space-y-4">
                {category.questions.map((faq, questionIndex) => {
                  const globalIndex = categoryIndex * 100 + questionIndex;
                  const isOpen = openIndex === globalIndex;
                  
                  return (
                    <div
                      key={questionIndex}
                      className="bg-white border-2 border-dark-100 rounded-xl overflow-hidden hover:border-primary-500 transition-all"
                    >
                      <button
                        onClick={() => setOpenIndex(isOpen ? null : globalIndex)}
                        className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer"
                      >
                        <h3 className="font-display font-semibold text-lg text-dark-900 pr-4">
                          {faq.question}
                        </h3>
                        <i className={`ri-arrow-${isOpen ? 'up' : 'down'}-s-line text-2xl text-primary-600 flex-shrink-0`}></i>
                      </button>
                      {isOpen && (
                        <div className="px-6 pb-5">
                          <p className="text-dark-600 leading-relaxed">
                            {faq.answer}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl text-dark-900 mb-6">
            Sorunuza Cevap Bulamadınız mı?
          </h2>
          <p className="text-xl text-dark-600 mb-8">
            Bizimle iletişime geçin, size yardımcı olmaktan mutluluk duyarız
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="/iletisim" 
              className="bg-primary-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary-700 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              İletişime Geç
            </a>
            <a 
              href="tel:+905XXXXXXXXX" 
              className="bg-dark-900 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-800 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-phone-line"></i>
              <span>Hemen Ara</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FaqPage;
